var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.406,
    height: 65.649,
    viewBox: "0 0 193.406 65.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #0061a7;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #b80473;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    className: "cls-1",
    width: 193.406,
    height: 65.649
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    className: "cls-3",
    d: "M65.473,64.747a.711.711,0,0,1-.492-.164.886.886,0,0,1-.254-.383L61.013,52.55a.445.445,0,0,1-.037-.164.366.366,0,0,1,.118-.265A.386.386,0,0,1,61.376,52h2.257a.616.616,0,0,1,.455.164.7.7,0,0,1,.2.309l2.584,8.41,2.567-8.41a.96.96,0,0,1,.211-.309A.581.581,0,0,1,70.1,52h2.275a.4.4,0,0,1,.383.383.463.463,0,0,1-.036.164L69,64.2a.762.762,0,0,1-.237.383.736.736,0,0,1-.51.164Z",
    transform: "translate(1.057 0.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    className: "cls-3",
    d: "M78.966,64.747a.427.427,0,0,1-.327-.136.452.452,0,0,1-.128-.318V52.46A.437.437,0,0,1,78.966,52h2.44a.477.477,0,0,1,.337.127.428.428,0,0,1,.137.329V64.292a.436.436,0,0,1-.137.318.459.459,0,0,1-.337.136Z",
    transform: "translate(1.361 0.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    className: "cls-3",
    d: "M91.879,64.747a.428.428,0,0,1-.328-.136.452.452,0,0,1-.128-.318V54.862h-3.24a.424.424,0,0,1-.328-.136.449.449,0,0,1-.127-.318V52.46A.436.436,0,0,1,88.183,52h9.794a.437.437,0,0,1,.456.456v1.947a.454.454,0,0,1-.128.318.425.425,0,0,1-.328.136h-3.24v9.431a.448.448,0,0,1-.128.318.429.429,0,0,1-.328.136Z",
    transform: "translate(1.521 0.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    className: "cls-3",
    d: "M102.193,64.747a.409.409,0,0,1-.384-.383.669.669,0,0,1,.019-.164l4.278-11.687a.727.727,0,0,1,.228-.355.7.7,0,0,1,.482-.155h2.694a.7.7,0,0,1,.482.155.728.728,0,0,1,.228.355L114.481,64.2a.387.387,0,0,1,.035.164.363.363,0,0,1-.117.263.387.387,0,0,1-.283.119h-2.238a.553.553,0,0,1-.41-.137.653.653,0,0,1-.173-.245l-.71-1.857h-4.861l-.692,1.857a.716.716,0,0,1-.164.245.578.578,0,0,1-.436.137Zm4.278-4.861h3.386l-1.694-4.806Z",
    transform: "translate(1.765 0.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    className: "cls-3",
    d: "M120.463,64.747a.427.427,0,0,1-.327-.136.452.452,0,0,1-.128-.318V52.46a.437.437,0,0,1,.455-.456h2.4a.436.436,0,0,1,.456.456V62h5.516a.431.431,0,0,1,.328.136.479.479,0,0,1,.128.337v1.821a.456.456,0,0,1-.128.318.431.431,0,0,1-.328.136Z",
    transform: "translate(2.08 0.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    className: "cls-4",
    d: "M176.709,0a6.521,6.521,0,0,0-6.521,6.521h13.041A6.521,6.521,0,0,0,176.709,0",
    transform: "translate(2.95 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    className: "cls-4",
    d: "M17.468,12.57A12.176,12.176,0,0,0,6.885,17.926V1.569H0V42.34H6.885v-4.8A12.176,12.176,0,0,0,17.468,42.9c8.416,0,14.293-6.212,14.293-15.106a15.848,15.848,0,0,0-3.987-10.921,13.884,13.884,0,0,0-10.306-4.3m-1.62,25.223c-5.445,0-8.963-3.948-8.963-10.06S10.4,17.671,15.848,17.671c5.365,0,8.834,3.949,8.834,10.061s-3.468,10.06-8.834,10.06",
    transform: "translate(0 0.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    className: "cls-4",
    d: "M88.04,12.382c-5.032,0-8.951,1.891-11.36,5.472V12.937H69.795V23.888a55.319,55.319,0,0,0-6.086-.753v-.313c0-6.44-5.576-10.44-14.553-10.44-5.763,0-10.3,1.769-13.487,5.258l-.081.089,4.828,3.4.079.057.063-.075a10.539,10.539,0,0,1,8.469-3.629c4.737,0,7.8,2.14,7.8,5.45v.078c-2.338.079-3.862.251-4.011.27l0,.007c-5.427.339-11.518,1.928-14.977,5.178a8.144,8.144,0,0,0-2.78,6.08c0,4.959,4.39,8.162,11.183,8.162,4.477,0,8.222-1.453,10.583-4.1v3.544h6.884V24.358a50.8,50.8,0,0,1,6.086.8V42.1H76.68V26.656c0-6.023,4.639-9.172,9.222-9.172,3.2,0,7.021,1.388,7.021,8.005V42.1h6.883V24.544c0-10.052-6.4-12.162-11.767-12.162M56.825,32.046c0,3.4-3.766,6.061-8.575,6.061-2.987,0-6.177-1.127-6.177-4.284a4.731,4.731,0,0,1,1.533-3.446c2.768-2.723,8.546-3.674,12.858-3.674h.361Z",
    transform: "translate(0.608 0.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    className: "cls-4",
    d: "M186.341,34.157a10.123,10.123,0,0,1-7.885,3.573,8.642,8.642,0,0,1-7.392-3.7l14.468-8.4,0,.026,6.1-3.448a14.461,14.461,0,0,0-3.227-5.561c-2.64-2.75-6.272-4.145-10.794-4.145-9.247,0-15.458,6.116-15.458,15.218a14.9,14.9,0,0,0,2.524,8.51l-7.657,4.447V13.061h-6.884v15.5h0c0,6.3-4.78,9.172-9.223,9.172-3.2,0-7.02-1.4-7.02-8.061V13.061H127.01V30.669a18.326,18.326,0,0,0,.383,3.824,14.283,14.283,0,0,1-4.9,2.659v-.007l-.132.034a16.145,16.145,0,0,1-3.989.552c-3.467,0-4.882-1.563-4.882-5.394V18.219H122.1v-5.1h-8.615V5.229H106.6v7.888h-4.34v5.1h4.34V32.448c0,6.6,4.076,10.384,11.184,10.384a20.387,20.387,0,0,0,4.626-.558l.079-.02v-3.7a14.621,14.621,0,0,0,5.293-2.6c1.854,5.544,6.739,6.885,10.99,6.885,5,0,8.919-1.892,11.36-5.476v4.921h6.884v0h0l8.5-4.935c2.892,3.434,7.46,5.493,13,5.493a16.5,16.5,0,0,0,12.711-5.258l.082-.089-4.91-3.4Zm-16.773-8.983h0c.559-4.671,3.631-7.567,8.044-7.567.074,0,.145.008.219.009a7.66,7.66,0,0,1,6.73,3.856L169.527,30.2c-.065-.355-.12-.718-.156-1.093h.05a11.853,11.853,0,0,1,.147-3.934",
    transform: "translate(1.773 0.091)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.f3f091c3925d44eaf9ecc1649e3fb1b1.svg";
export { ForwardRef as ReactComponent };